<template>
  <div ref="sticky-container" class="sticky-container" :style="containerStyle">
    <div :class="{fixed:isFixed, mobile: onMobile}" :style="topStyle" class="sticky-content">
      <div class="container" :class="contentClasses">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        containerHeight: null,
        isFixed: false,
        top: 0
      }
    },
    props: {
      onMobile: {
        type: Boolean,
        default: false
      },
      resized: Boolean,
      contentClasses: String
    },
    mounted() {
      this.setContainerHeight()
      this.setTopStyle()

      window.addEventListener('scroll', this.onScroll)
      window.addEventListener('resize', this.onResize)
    },
    unmounted() {
      window.removeEventListener('scroll', this.onScroll)
      window.removeEventListener('resize', this.onResize)
    },
    computed: {
      containerStyle() {
        if (this.containerHeight) return `height: ${this.containerHeight}px;`
      },
      topStyle() {
        return this.top ? `top: ${this.top}px;` : '0px'
      }
    },
    methods: {
      setContainerHeight() {
        if (!this.containerHeight) this.containerHeight = this.$refs['sticky-container'].offsetHeight
      },
      setTopStyle() {
        // The offset of the sticky will be the combined widths of the content above it. will need to be updated if anything else is added/removed

        this.top = document.getElementById('mainNavbar').offsetHeight + 3
      },
      onResize() {
        this.containerHeight = null
        this.setContainerHeight()
        this.setTopStyle()
      },
      onScroll() {
        const target = this.$refs['sticky-container']
        if (window.scrollY > target.offsetTop - target.offsetHeight) {
          this.isFixed = true
        } else this.isFixed = false
      }
    },
    watch: {
      resized() {
        // Optionally pass in a resize paramater that will rerender the height on the passed prop's change
        this.containerHeight = null
      }
    }
  }
</script>
